import Route from '@ember/routing/route';
import type { ModelFrom } from 'tio-employee/types/route-model';
import type TasRoute from '../../../tas';

export default class AuthenticatedCareerPathwaysTasApplicationsTypeFourNewRoute extends Route {
  model(params: Record<string, unknown>) {
    const applicationId = params['tas_application_id'] as string;
    return {
      ...(this.modelFor('authenticated.reimagined.tas') as ModelFrom<TasRoute>),
      applicationId,
      applicationType: 'type-four',
    };
  }
}
